import React from 'react';

const SubHeader = ({ expenseFilter, addButtonComponent,
  searchComponent, filterButton, downloadButton, dropdownSelect }) => {
  return (
    <div>
      <div className=" table-control-wrap">
        <div className="flex flex-1 items-center table-control-btn">
          {searchComponent}
          {dropdownSelect}
        </div>
        <div className="table-control-btn">
          {downloadButton}
          {addButtonComponent}
        </div>
      </div>
      <div className="flex justify-end">{filterButton}</div>
      {expenseFilter}
    </div>
  );
};

export default SubHeader;
